<template>
<div>
    <RealtimeWorkerChart/>
    <vs-table :data="users" max-items="5" pagination >
      <template slot="thead" >
        <vs-th >
        Check-in
        </vs-th>
        <vs-th>
        Check-out
        </vs-th>
      </template>

      <template slot-scope="{data}">
         
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          
          <vs-td  :data="data[indextr].in" style="padding: 20px;">
            {{data[indextr].in}}
          </vs-td>

          <vs-td :data="data[indextr].out" style="padding: 20px;">
            {{data[indextr].out}}
          </vs-td>
        </vs-tr>
         
      </template>
    </vs-table>
</div>
</template>
<script>

import RealtimeWorkerChart from './components/RealtimeWorkerChart.vue'
export default {
    components: {
    RealtimeWorkerChart,
  },
   data: () => ({
    users:[
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
      {
        "in": "08:30",
        "out": "15:30",
      },
    ]
  }),
}
</script>
